<template>
    <resource-index title="Счета на оплату" endpoint="admin/billing/invoices">
        <template v-slot:table-header>
            <tr class="border-b">
                <th class="text-left p-3 px-5" scope="col">Заказ</th>
                <th class="text-left p-3 px-5" scope="col">Товар</th>
                <th class="text-left p-3 px-5" scope="col">Клиент</th>
                <th class="text-left p-3 px-5" scope="col">Стоимость</th>
                <th class="text-left p-3 px-5" scope="col">Статус</th>
                <th class="text-left p-3 px-5" scope="col">Дата</th>
                <th class="text-left p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:table-filters="slotProps">
            <tr class="border-b bg-gray-100">
                <th class="p-3 px-5" scope="col"></th>

                <th class="p-3 px-5" scope="col">
                    <select-field
                        label="name"
                        valueName="id"
                        :wrap="false"
                        :options="selects.products"
                        v-model="slotProps.filters.product_id"
                    />
                </th>

                <th class="p-3 px-5" scope="col">
                    <text-field
                        :wrap="false"
                        v-model="slotProps.filters.customer"
                    />
                </th>

                <th class="p-3 px-5" scope="col"></th>

                <th class="p-3 px-5" scope="col">
                    <select-field
                        label="label"
                        valueName="name"
                        :wrap="false"
                        :options="selects.statuses"
                        v-model="slotProps.filters.status"
                    />
                </th>

                <th class="p-3 px-5" scope="col"></th>

                <th class="p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:row="slotProps">
            <td class="p-3 px-5">
                <span class="badge whitespace-no-wrap badge-indigo"
                    >Заказ #{{ slotProps.entry.order.id }}</span
                >
            </td>

            <td class="p-3 px-5">{{ slotProps.entry.order.product.name }}</td>

            <td class="p-3 px-5">
                {{ slotProps.entry.order.customer.full_name }}
            </td>

            <td class="p-3 px-5">
                <span class="badge whitespace-no-wrap badge-success"
                    >{{ slotProps.entry.amount }} ₽</span
                >
            </td>

            <td class="p-3 px-5">
                <span
                    class="badge whitespace-no-wrap badge-success"
                    v-if="slotProps.entry.status == 'paid'"
                    >Оплачен</span
                >
                <span
                    class="badge whitespace-no-wrap badge-gray"
                    v-if="slotProps.entry.status == 'pending'"
                    >Ожидание</span
                >
                <span
                    class="badge whitespace-no-wrap badge-warning"
                    v-if="slotProps.entry.status == 'cancelled'"
                    >Отменен</span
                >
            </td>

            <td class="p-3 px-5">
                {{
                    localTime(
                        slotProps.entry.paid_at
                            ? slotProps.entry.paid_at
                            : slotProps.entry.created_at
                    )
                }}
            </td>

            <td class="p-3 px-5">
                <router-link
                    :to="{
                        name: 'admin.billing.invoices.show',
                        params: {
                            id: slotProps.entry.id,
                        },
                    }"
                    class="btn btn-info"
                    >Открыть</router-link
                >
            </td>
        </template>
    </resource-index>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex,
    },

    data() {
        return {
            selects: {
                ready: false,
                products: [],
                statuses: [
                    {
                        name: "pending",
                        label: "Ожидание",
                    },
                    {
                        name: "paid",
                        label: "Оплачен",
                    },
                    {
                        name: "cancelled",
                        label: "Отменен",
                    },
                ],
            },
        };
    },

    methods: {
        async fetchSelects() {
            await axios.get("/admin/products/all").then((response) => {
                this.selects.products = response.data.data;
            });

            this.selects.ready = true;
        },
    },

    mounted() {
        this.fetchSelects();
    },
};
</script>